export default __webpack_public_path__ + "static/media/Jogo-Do-Bicho_Volume_1.2a47b85b.svg";